module.exports = __webpack_public_path__ + "static/img/Gilles_Vermot_Desroches_2017.b29d620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/Gilles_Vermot_Desroches_2017.jpg
// module id = TZZL
// module chunks = 0